const printUtil = function (id, title = '') {
  let table = document.getElementById(id);
  //display block
  table.style.display = 'block';
  let printWindow = window.open();
  printWindow.document.open();
  printWindow.document.write('<html><head><title>'+ title +'</title>');
  printWindow.document.write('<style>.print-table { border-collapse: collapse; }  .print-table th, .print-table td { border: 1px solid black; padding: 8px; }</style>');
  printWindow.document.write('<style>.print-page-break { page-break-after: always; } </style>');
  printWindow.document.write('</style></head><body>');
  printWindow.document.write(table.outerHTML);
  printWindow.document.write('</body></html>');
  printWindow.document.close();
  printWindow.print();
  table.style.display = 'none';
  printWindow.addEventListener('afterprint', () => {
    printWindow.close();
  });
};

/**
 * Reusable print helper
 * @param {String} elementId - ID of the div/table to print
 * @param {String} title - Print page title
 */
export function apiPrintData(elementId, title = '') {
  const element = document.getElementById(elementId);
  if (!element) {
    console.warn(`Print element with id "${elementId}" not found!`);
    return;
  }

  const originalDisplay = element.style.display;
  element.style.display = 'block';

  const pw = window.open('', '_blank');
  if (!pw) {
    element.style.display = originalDisplay;
    return;
  }

  pw.document.open();
  pw.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: Arial, sans-serif; font-size: 12px; }
          .print-table { border-collapse: collapse; width: 100%; }
          .print-table th, .print-table td { border: 1px solid black; padding: 8px; }
          .print-page-break { page-break-after: always; }
          h2, h3, h4 { margin: 5px 0; }
        </style>
      </head>
      <body>
        ${element.outerHTML}
      </body>
    </html>
  `);
  pw.document.close();
  pw.focus();

  pw.print();
  element.style.display = originalDisplay;

  pw.addEventListener('afterprint', () => pw.close());
}


export { printUtil };
